const responseHappinessTips = {
  payload: [
    {
      idTip: 1,
      title: "Tip de prueba 1",
      message: "Mensaje de prueba 1",
      happinessCategoryTipsId: 1,
      happinessCategoryTipsName: "Categor�a 1",
      active: true,
      miniature: null,
      detail: null,
      fileLink: null
    },
    {
      idTip: 2,
      title: "Tip de prueba 2",
      message: "Mensaje de prueba 2",
      happinessCategoryTipsId: 2,
      happinessCategoryTipsName: "Categor�a 2",
      active: true,
      miniature: null,
      detail: null,
      fileLink: null
    }
  ]
};

const responseCreate = {
  payload: {
    message: "Tip creado exitosamente"
  }
};

const responseUpdate = {
  payload: {
    message: "Tip actualizado exitosamente"
  }
};

const responseDelete = {
  payload: {
    message: "Tip eliminado exitosamente"
  }
};

export const service = {
  getHappinessTips: () => new Promise(resolve => {
    setTimeout(() => resolve({ data: responseHappinessTips }), 500);
  }),

  createHappinessTip: () => new Promise(resolve => {
    setTimeout(() => resolve({ data: responseCreate, status: 200 }), 500);
  }),

  updateHappinessTip: () => new Promise(resolve => {
    setTimeout(() => resolve({ data: responseUpdate, status: 200 }), 500);
  }),

  deleteHappinessTip: () => new Promise(resolve => {
    setTimeout(() => resolve({ data: responseDelete, status: 200 }), 500);
  })
};
